import { useState } from 'react';
import { useAlertContext } from '../context/alertContext';

// const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms)); // Remove simulation

/**
 * Custom hook to submit form data to the backend API route.
 */
const useSubmit = () => {
  const [isLoading, setLoading] = useState(false);
  const { setResponseData, onOpen } = useAlertContext();

  const submit = async (url, data) => { // url argument is no longer strictly needed but kept for now
    setLoading(true);
    setResponseData(null); // Clear previous response

    try {
      // Send data to the API route
      const apiResponse = await fetch('/api/send-email', { // Call our new API route
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await apiResponse.json();

      if (!apiResponse.ok) {
        // If API returned an error status (4xx, 5xx)
        throw new Error(result.message || `HTTP error! status: ${apiResponse.status}`);
      }

      // Handle success
      const successResponse = {
        type: 'success',
        message: `Thanks for your submission ${data.firstName}, we will get back to you shortly!`,
        // Or use result.message if the API provides a success message:
        // message: result.message,
      };
      setResponseData(successResponse);
      onOpen(successResponse.type, successResponse.message);

    } catch (error) {
      console.error("Submission Error:", error);
      const errorResponse = {
        type: 'error',
        message: error.message || 'Something went wrong, please try again later!',
      };
      setResponseData(errorResponse);
      onOpen(errorResponse.type, errorResponse.message);

    } finally {
      setLoading(false);
    }
  };

  return { isLoading, submit };
};

export default useSubmit;
